/* Version F PDP QA: fallback visibility controller for Prestige's native sticky ATC. */
(() => {
  'use strict';
  if (!document.body.classList.contains('phf-page-product')) return;

  let raf = 0;

  const sync = () => {
    raf = 0;
    const sticky = document.querySelector('product-sticky-bar');
    const purchaseBlock = document.querySelector('.product-info [data-block-type="buy-buttons"]');
    if (!sticky || !purchaseBlock) return;

    const shouldShow = purchaseBlock.getBoundingClientRect().bottom <= 0;
    sticky.classList.toggle('is-visible', shouldShow);
    sticky.toggleAttribute('data-phf-sticky-visible', shouldShow);
  };

  const schedule = () => {
    if (!raf) raf = requestAnimationFrame(sync);
  };

  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  document.addEventListener('variant:change', () => setTimeout(schedule, 0), { capture: true });
  document.addEventListener('shopify:section:load', schedule);

  const observer = new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        if ((node.matches && node.matches('product-sticky-bar, [data-block-type="buy-buttons"]')) ||
            (node.querySelector && node.querySelector('product-sticky-bar, [data-block-type="buy-buttons"]'))) {
          schedule();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  schedule();
  setTimeout(schedule, 250);
  setTimeout(schedule, 1000);
})();
